import React from 'react';
import { connect } from 'react-redux';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import GaATMLimits from 'apps/auth/components/ga/cards/details/GaATMLimits';
import BasePage from 'apps/auth/components/utils/BasePage';

const CardLimitsPage = (props) => {
    return (
        <CommonPage backUrl={props.backLink} showChat={false}>
            {props.atm_limit && <GaATMLimits />}
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        atm_limit: state.extra.atm_limit,
        backLink: state.extra.backLink,
    };
};
export default connect(mapStateToProps)(BasePage(CardLimitsPage));
